'use client';
import React from 'react';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  isBulk: boolean;
  bulkCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function DeleteConfirmModal({ isOpen, isBulk, bulkCount, onConfirm, onCancel }: DeleteConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="delete-modal-title">
      <div className="absolute inset-0 bg-foreground/20 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative bg-card rounded-3xl border border-border shadow-xl-custom p-6 w-full max-w-sm animate-scale-in">
        <div className="w-12 h-12 rounded-2xl bg-rose-50 border border-rose-100 flex items-center justify-center mb-4">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="#E11D48" strokeWidth="1.8" strokeLinecap="round">
            <path d="M3 6h16M8 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M18 6l-.8 13a2 2 0 0 1-2 1.8H6.8a2 2 0 0 1-2-1.8L4 6" />
            <path d="M9.5 10.5v5M12.5 10.5v5" />
          </svg>
        </div>
        <h3 id="delete-modal-title" className="font-bold text-foreground" style={{ fontSize: '17px' }}>
          {isBulk ? `Delete ${bulkCount} QR codes?` : 'Delete this QR code?'}
        </h3>
        <p className="text-muted-foreground mt-2" style={{ fontSize: '14px' }}>
          {isBulk
            ? `This will permanently delete ${bulkCount} QR code records. This action cannot be undone.`
            : 'This will permanently delete this QR code record. This action cannot be undone.'}
        </p>
        <div className="flex gap-3 mt-6">
          <button
            onClick={onCancel}
            className="btn-secondary flex-1 py-3 rounded-2xl"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-3 rounded-2xl font-semibold text-white transition-all duration-200 hover:opacity-90 active:scale-95"
            style={{ background: '#E11D48', fontSize: '14px' }}
          >
            Delete {isBulk ? `${bulkCount} records` : 'record'}
          </button>
        </div>
      </div>
    </div>
  );
}